<template>
  <div class="assessment-option-input">
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      data-analytics-skip
      class="assessment-option-input__option"
      :class="{ 'assessment-option-input__option--selected': isSelected(option.value) }"
      data-testid="assessment-option"
      :aria-pressed="String(isSelected(option.value))"
      @click="select(option.value)"
    >
      <span class="assessment-option-input__control">
        {{ selectionIndicator(option.value) }}
      </span>{{ option.label }}
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import type { AssessmentInputOption } from './types'
import './styles/OptionInput.css'

export default defineComponent({
  name: 'AssessmentOptionInput',
  props: {
    options: { type: Array as PropType<AssessmentInputOption[]>, default: () => [] },
    value: { type: [String, Array] as PropType<string | string[] | null>, default: null },
    multiple: { type: Boolean, default: false },
  },
  emits: ['input', 'select'],
  computed: {
    selectedValues(): string[] {
      if (Array.isArray(this.value)) return this.value
      return this.value === null || this.value === '' ? [] : [this.value]
    },
  },
  methods: {
    isSelected(value: string): boolean {
      return this.selectedValues.includes(value)
    },
    selectionIndicator(value: string): string {
      if (!this.isSelected(value)) return ''
      return this.multiple ? '✓' : '●'
    },
    select(value: string): void {
      let nextValue: string | string[] = value

      if (this.multiple) {
        if (this.isSelected(value)) {
          nextValue = this.selectedValues.filter(selected => selected !== value)
        } else {
          nextValue = [...this.selectedValues, value]
        }
      }

      this.$emit('input', nextValue)
      this.$emit('select', value)
    },
  },
})
</script>
